import React,{useState,useEffect} from 'react'
import {
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Label,
    Button,
    DropdownToggle,
    DropdownItem,
    DropdownMenu,
    ButtonDropdown,
} from "reactstrap";
import { apiCall } from '../../functions/utils';
import  AsyncCreatable from 'react-select/async-creatable';
import { useSelector,useDispatch } from 'react-redux';
import { sendToNewNumbers, setChatPhone,fetchContacts ,fetchMessages,fetchChat} from '../../redux/action';
import { encodePhoneNumber } from '../../helpers/Utils';
export default function NewMessageModal({isVisible=true,toggle,number=null,contacts, type, tags}) {
  const dispatch=useDispatch()
  const customMessages=useSelector((state)=>state.customMessages)  
  const messages=useSelector((state)=>state.messages)
  const [newNumber,setNewNumber]=useState([number])
  const [textMessage,setTextMessage]=useState('')
  const [btnDropup,setBtnDropup]=useState(false)
   const [options,setOptions]=useState([])
  
   const onSelectChange=(value)=>{
   setNewNumber(value)
  }

  
  

  const sendMessage=()=>{
    if(newNumber.length<1 || textMessage==='')
    return
    dispatch(sendToNewNumbers(textMessage, newNumber, type))

    dispatch(fetchMessages())
    dispatch(setChatPhone(messages.length > 0 && messages.data[0].sender_phone))
    dispatch(fetchChat())
  }

 const getContacts=()=>{
  dispatch(fetchContacts())
 }

 const getOptions=()=>{
  const arr=contacts?.data.map(item =>({value: item.phone_no, label: item.full_name}))
  setOptions(arr)
 }
 
 useEffect(()=>{
  setTextMessage("")
  setNewNumber([number])
  //getOptions()
  },[isVisible==true])

  const handleBlur=(e)=>{
    if (type === "group") return;
    if(e.target.value.length>0){
    let newObj={
      label: e.target.value,
      value: e.target.value,
    };
   setNewNumber([...newNumber,newObj])
  }
  }

  const promiseOptions = async(inputValue,callback) =>{
   // console.log("HIIIIII")
    // console.log(inputValue)
    const res = await apiCall(true, "GET", `/api/contacts?query=${inputValue}&page=1`)
    let options = []
    if( res && res.data && res.data.data ){
        res.data.data.map( item => {
            options.push({ value: item.phone_no, label: item.full_name })
        })
    }
    callback( options )
}

  return  (
    <Modal isOpen={isVisible} toggle={toggle} >
            <ModalHeader>
                New Message
            </ModalHeader>
            <ModalBody>
                <Label className="mt-2">
                    To:
                </Label>
                
                {type === "individual" && (
                  <AsyncCreatable
                    style={{ marginTop: "0px" }}
                    defaultOptions={contacts?.data.map((item) => ({
                      value: item.phone_no,
                      label: item.full_name,
                    }))}
                    isMulti
                    //ref={s => this.creatable = s}
                    value={newNumber}
                    defaultValue={newNumber}
                    onBlurResetsInput={false}
                    onBlur={handleBlur}
                    placeholder=""
                    onChange={onSelectChange}
                    loadOptions={promiseOptions}
                    formatCreateLabel={(userInput) => `Add  ${userInput}`}
                  />
                )}

                {type === "group" && (
                  <AsyncCreatable
                    defaultOptions={[
                        { value: "all", label: "All contacts" },
                        ...(Array.isArray(tags?.data)
                          ? tags.data.map(item => ({
                              value: item.id,
                              label: item.tag,
                            }))
                          : []
                      )
                    ]}
                    isMulti
                    value={newNumber}
                    defaultValue={newNumber}
                    onChange={(value) => setNewNumber(value)}
                    placeholder="Select Tags"
                  />
                )}
                <Label>
                    Message
                </Label>
                <textarea
                    // name = "text_message"
                    className={"form-control"}
                   // ref={c=>this.textarea=c}
                    
                    value = {textMessage }
                    rows={3} 
                    onChange = {(e)=>setTextMessage(e.target.value)}
                />

                <ButtonDropdown
                    direction="up"
                    className="mt-2"
                    // color="primary" 
                    style={{borderRadius: '2em !important'}}

                   isOpen={btnDropup}
                   toggle={() => {
                    setBtnDropup(old=>!old)
                    }}
                  >
                    <DropdownToggle caret size="sm" className=" mr-1"  style={{backgroundColor:'#5C5BE3'}}  >
                    {/* <i className="simple-icon-arrow-up" /> */}
                      Template
                    </DropdownToggle>

                    <DropdownMenu style={{maxHeight:"15em", overflowY: "scroll", bottom:"1em",height: "fit-content"}}>
                      { customMessages.templates.length>0 && customMessages.templates.map( item => {
                        return(
                          <DropdownItem key={item.id} onClick={()=>setTextMessage(item.text_message)}
                          >
                            {item.name}
                          </DropdownItem>
                        )
                      } )}
                      
                    </DropdownMenu>
                  </ButtonDropdown>

        </ModalBody>
          
        <ModalFooter>
            <Button  style={{backgroundColor:'#5C5BE3'}} onClick={()=>{sendMessage();toggle()}}>
                Send
            </Button>{" "}
            <Button color="secondary" 
             onClick={toggle}
            >
                Cancel
            </Button>
        </ModalFooter>
    </Modal>
  )
}
